<template>
  <div>
    <OrderSummaryResponsiveLayout :summary="summary" class="print-excluded" />
    <OrderSummaryPrintLayout :summary="summary" class="print-only" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import OrderSummaryResponsiveLayout from '@/components/OrderSummaryResponsiveLayout.vue';
import OrderSummaryPrintLayout from '@/components/OrderSummaryPrintLayout.vue';

export default {
  name: 'OrderSummary',
  components: { OrderSummaryResponsiveLayout, OrderSummaryPrintLayout },
  data: () => ({
    summary: undefined,
  }),
  async created() {
    this.summary = await this.getOrderSummary(this.$route.query.order_key);
    this.setLoading(false);
  },
  methods: {
    ...mapActions(['setLoading', 'getOrderSummary']),
  },
};
</script>

<style scoped></style>
